import {
  mapGetters,
  mapMutations,
} from 'vuex';

import changeIcon from '@/assets/images/icons/change.svg';
import newTiresIcon from '@/assets/images/icons/new-tires.svg';
import alignmentIcon from '@/assets/images/icons/alignment.svg';
import maintenanceIcon from '@/assets/images/icons/maintenance.svg';

export default {
  name: 'ServiceTypePicker',
  components: {
    changeIcon,
    newTiresIcon,
    alignmentIcon,
    maintenanceIcon,
  },
  props: {
    showMaintenance: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({}),
  computed: {
    ...mapGetters('appointment', {
      serviceType: 'getServiceType',
    }),
  },
  methods: {
    ...mapMutations('appointment', {
      setServiceTypeMutation: 'SET_SERVICETYPE',
    }),
    setServiceType(serviceType) {
      this.setServiceTypeMutation(serviceType);
    },
  },
};
